import axiosInstance from "../../_helpers/axios_instance";

export const fetchInsightData = async ({ endpoint, filters }) => {
  const params = {
    ...filters // spread any additional filters as query params
  };

  try {
    const response = await axiosInstance.get(
      `/api/insights/${endpoint}`,
      {
        params,
      }
    );
    // This line only runs if the request is successful
    return response.data.data;
  } catch (error) {
    // This block runs if the API call fails for any reason (e.g., 401, 500).
    // Your interceptor will handle the logout on a 401, and this catch
    // block will prevent the "uncaught error" from crashing the app.
    console.error(`Failed to fetch insight data for endpoint: ${endpoint}`, error);

    // Return a safe, empty value so the UI doesn't break
    // when it tries to use the data. An empty array is often a good default.
    return [];
  }
};